import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";
import { CustomBounce } from "gsap/CustomBounce";
import { CustomEase } from "gsap/all";

gsap.registerPlugin(CustomBounce, CustomEase);
export default class UIButton extends DefaultBlock {
	init() {
		this.DOM = {
			mask: this.block.querySelector("#ui-hero-mask"),
			squareStart: this.block.querySelector("#square_start"),
			checkbox: this.block.querySelector("#checkbox"),
			checkboxCircle: this.block.querySelector("#checkbox_circle"),
			checkboxInner: this.block.querySelector("#checkbox_inner"),
			diamond: this.block.querySelector("#diamond"),
			toggle: this.block.querySelector("#toggle"),
			toggleTube: this.block.querySelector("#toggle_tube"),
			toggleCircle: this.block.querySelector("#toggle_circle"),
			flower: this.block.querySelector("#flower"),
			squareEnd: this.block.querySelector("#square_end"),
		};

		this.animate();
	}

	animate() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			const toggleWidth = 326;

			gsap.set(
				[
					this.DOM.checkbox,
					this.DOM.diamond,
					this.DOM.toggle,
					this.DOM.flower,
					this.DOM.squareEnd,
				],
				{
					opacity: 0,
				}
			);

			const buildOnTl = gsap
				.timeline({
					defaults: {
						ease: "back.out(1)",
						duration: 0.4,
					},
				})
				.from(this.DOM.squareStart, {
					scale: 0,
					transformOrigin: "50% 50%",
					ease: "power3.out",
				})
				.set(
					[
						this.DOM.checkbox,
						this.DOM.diamond,
						this.DOM.toggle,
						this.DOM.flower,
						this.DOM.squareEnd,
					],
					{
						opacity: 1,
					}
				)
				.from(this.DOM.checkbox, {
					x: -124,
				})
				.from(
					this.DOM.diamond,
					{
						x: -124 * 2,
					},
					"<"
				)
				.from(
					this.DOM.toggle,
					{
						x: -124 * 3 - toggleWidth,
					},
					"<"
				)
				.from(
					this.DOM.flower,
					{
						x: -124 * 4 - toggleWidth,
					},
					"<"
				)
				.from(
					this.DOM.squareEnd,
					{
						x: -124 * 5 - toggleWidth,
					},
					"<"
				)
				.set(
					this.DOM.mask,
					{
						overflow: "visible",
					},
					0.6
				);

			const spinTl = gsap.timeline().to(this.DOM.diamond, {
				rotate: -360,
				transformOrigin: "50% 50%",
				ease: "power3.inOut",
				duration: 0.8,
			});

			CustomBounce.create("flower-bounce", { strength: 0.6, endAtStart: true });

			const flipTl = gsap
				.timeline()
				.to(
					this.DOM.flower,
					{
						y: "-=218",
						duration: 1.5,
						ease: "flower-bounce",
					},
					"<"
				)
				.to(
					this.DOM.flower,
					{
						rotate: "-=270",
						transformOrigin: "50% 50%",
						duration: 1,
						ease: "back.inOut",
					},
					"<"
				);

			const tl = gsap
				.timeline({
					id: "ui-hero",
					defaults: {
						ease: "back.out(1)",
						duration: 0.3,
					},
				})
				.add(buildOnTl)
				.from(this.DOM.checkboxInner, {
					scale: 0,
					transformOrigin: "50% 50%",
				})
				.add(spinTl, ">-0.2")
				.from(
					this.DOM.toggleCircle,
					{
						x: -196,
						ease: "back.inOut(1)",
						duration: 0.4,
					},
					"<+0.2"
				)
				.add(flipTl);

			// GSDevTools.create();
		});
	}
}
